module.exports = __webpack_public_path__ + "static/media/Mobilebanner.588a5451.png";